import React from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
} from "@mui/material";

interface SelectInputProps {
  field: string;
  formData: any;
  onChange: (field: string, value: string) => void;
  options: string[] | { label: string; value: string }[];
  label?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
}

const SelectInput: React.FC<SelectInputProps> = ({
  field,
  formData,
  onChange,
  options,
  label,
  required = false,
  disabled = false,
  error,
}) => (
  <FormControl 
    fullWidth 
    size="small" 
    required={required} 
    error={!!error}
    sx={{
      "& .MuiInputLabel-asterisk": {
        color: "red !important",
      },
    }}
  >
    <InputLabel
      sx={{
        "&.MuiInputLabel-asterisk": {
          color: "red !important",
        },
        "& .MuiInputLabel-asterisk": {
          color: "red !important",
        },
      }}
    >
      {label || "(Select)"}
    </InputLabel>
    <Select
      value={formData[field]}
      onChange={(e) => onChange(field, e.target.value)}
      label={label}
      disabled={disabled}
    >
      {options.map((opt) => {
        const isObject = typeof opt === 'object';
        const value = isObject ? opt.value : opt;
        const label = isObject ? opt.label : opt;
        return (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        );
      })}
    </Select>
    {error && (
      <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.75 }}>
        {error}
      </Typography>
    )}
  </FormControl>
);

export default SelectInput;
